<template>
  <div>
    <!--#region -- Header ---->

    <div>
      <div class="caption-label">
        <b-breadcrumb :items="pages" style="margin: 0px; padding: 5px 14px;"></b-breadcrumb>
      </div>
      <div class="row">
        <div class="col">
          <div class="row">
            <div class="col-3">
              <div class="label mt-2">SA Dept.:</div>
              <div class="sub-label"></div>
              <b-form-select v-model="department" :options="department_options"
                label="SA Dept.:" @change="onChangeDepartment"></b-form-select>
            </div>
            <div class="col-2">
              <div class="label mt-2">GRO PM Dept.:</div>
              <b-form-select v-model="member" :options="member_options" label="Department:" @change="onChangeMember"></b-form-select>
            </div>
            <div class="col-auto align-self-end">
              <b-button @click="$emit('editSelectionModal', member, 'groisr')" variant="primary">Add GRO ISR</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--#endregion -- Header ---->
    <!--#region -- Body ---->

    <div class="mt-3" v-if="table_show==true">

      <!-- fix IE Browser min-height: 2.5rem -->
      <div class="table-responsive" style="min-height: 2.5rem">
        <b-table striped :fields="fields"
                 :items="ISRData" small
                 thead-class="thead-light text-dark"
                 :busy="searching"
                 style="width: calc(100% - 10px)">

          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>

          <template #cell(company_id)="data">
            <span>
              {{data.item.company_id}}
            </span>
          </template>

          <template #cell(company_name)="data">
            <span>
              {{data.item.company_name}}
            </span>
          </template>

          <template #cell(gro_isr)="data">
            <span>
              {{data.item.gro_isr}}
            </span>
          </template>

          <template #cell(gro_user)="data">
            <span>
              <div v-for="i in data.item.gro_user.length">
                {{ data.item.department[i-1] +"; "+ data.item.gro_user[i-1] }}
              </div>
            </span>
          </template>

          <template #cell(action)="data">
            <div>
              <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-edit"
                  @click="$emit('editSelectionModal', data.item, 'groisr')"></button>
              <button  type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-delete"
                  @click="$emit('deleteModal', 'groisr', data.item, department)"></button>
            </div>
          </template>

        </b-table>
      </div>
    </div>

    <!--#endregion -- Body ---->

  </div>

</template>

<script>
  import * as moment from 'moment/moment';
  export default {
    name: 'admin',
    props: ['ISRData', 'member_options', 'department_options',
          'table_show', ],
    watch: { 
      member_options: function(newVal, oldVal) { // watch it
        this.member = newVal[0].value
        console.log(newVal)
      },
      department_options: function(newVal, oldVal) { // watch it
        this.department = newVal[0].value
        console.log(newVal)
      }
    },
    data() {
      return {
        // function_name: 'Admin-Memeber Setting-Add ISR',
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        authUrl: '',
        frontendUrl: '',
        userInfo: '',
        userEmail: '',
        userFunctions: [],
        userRoles: [],
        userSites: [],
        member: '',
        department: '',

        pages: [
          { text: 'Admin-Member Setting', href: '' },
          { text: 'Add GRO ISR', active: true }
        ],

        fields: [
          { key: 'company_id', label: 'company_id', thClass: 'align-middle', sortable: false },
          { key: 'company_name', label: 'company_name', thClass: 'align-middle', sortable: false },
          { key: 'gro_isr', label: 'gro_isr', thClass: 'align-middle', sortable: true },
          { key: 'gro_user', label: 'gro_user', thClass: 'align-middle', sortable: false },
          { key: 'action', label: 'Actions', thClass: 'align-middle', sortable: false }
        ],
        searchedData: [],
        login_user_name: '',
        searching: false,
        pageDisabled: true,
      }
    },
    created() {
      let self = this;
      let request_data = {
        action: 'load',
        department: '',
      };
      self.$parent.getISR(request_data);

    },
    computed: {

    },
    mounted: function () {
      this.checkLoggedIn();
      this.authUrl = this.$options.filters['authUrl']();
      this.frontendUrl = this.$options.filters['frontendUrl']();
      this.pages[0]['href'] = this.$root.frontEndUrl + "/admin-member/setting"
    },
    methods: {
      logout() {
        this.$session.destroy();
        this.$store.commit('clearToken');
        var url = this.$root.baseUrl + '/auth/logout/'
        this.$axios.get(url)
          .then((res) => {
            console.log('logout');
            this.$router.push("/");
          })
        window.location.href = this.authUrl + 'Auth/SignOut' + '?redirect_uri=' + encodeURIComponent(this.frontendUrl + 'azure-login');
      },
      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');

        console.log("this.$session.get('options')");
        console.log(options);
        console.log(options.model_list);
        console.log("login_user_name:");
        console.log(user_name);
        console.log("user_email:");
        console.log(user_email);
        console.log("user_functions:");
        console.log(user_functions);
        console.log("user_roles:");
        console.log(user_roles);
        console.log("user_site:");
        console.log(user_site);

        this.login_user_name = user_name;
        this.userEmail = user_email;
        this.userFunctions = user_functions;
        this.userRoles = user_roles;
        this.userSites = user_site;

      },
      onChangeDepartment(department) {
        let departmentText = department;
        this.department = department;
        if('' === department){
          departmentText = '---Select All---';
        }
        let request_data = {
          action: 'getlist',
          department: this.department,
        };
        this.$parent.getISR(request_data);
      },
      onChangeMember(member) {
        let memberText = member;
        this.member = member;
        if('' === member) {
          memberText = this.member_options[0];
        }
      },
      // exit() {
      //   window.open('', '_self', '');
      //   window.close();
      // }
    },
    filters: {

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/MemberSettingAddISR.vue